import U from '../js/utils';
import svg from '../js/svg';

export default async (elID, isChecked, valueData, requiredYN, inputDOB) => {
  return new Promise((resolve, reject) => {
    try {
      const showAutofill = U.canAutofillId();
      const autofillMarkup = showAutofill
        ? `<div id="${elID}_autofill_icon" class="cursor-pointer" onclick="U.autoFillID('${elID}')" title="Auto-fill test ID number"></div>`
        : '';

      const div = `
 <div id="${elID}Div">
  <div class="flex items-center justify-between">
       <label class="switch">
           <input type="checkbox" id="${elID}_toggle" 
           ${isChecked ? 'checked' : ''} 
           onchange="U.IdPassToggle('${elID}')">
           <span class="toggle round"></span>
       </label>
       <div class="flex items-center gap-2">
         <label id="${elID}_toggle_label" class="tgglLable" for="${elID}_toggle">${isChecked ? 'ID Number' : 'Passport Number'}</label>
         ${autofillMarkup}
       </div>
   </div>
   
   
    <div class="input-group">
     <input type="text" id="${elID}" name="${elID}" value="${valueData || ''}" ${requiredYN ? 'required' : ''} val=${isChecked ? 'idNumber' : 'text'}
   ${inputDOB && `onkeyup="U.populateDOB(this.value, '${inputDOB}')"`}
/>
    <span fb-for="${elID}"></span>
   
   </div>
   </div>
   
   `;
      const element = U.createHTMLElementFromString(div);

      if (showAutofill) {
        const iconContainer = element.querySelector(`#${elID}_autofill_icon`);
        iconContainer.appendChild(svg.magicWand());
      }

      resolve(element);
    } catch (error) {
      reject(new Error(error));
    }
  });
};
